module.exports = __webpack_public_path__ + "img/2025-11-17c_1.657797cb.jpg";